<script setup lang="ts">
import { defineQuery } from "groq";

const POSTS_QUERY = defineQuery(
  `*[_type == "post"] | order(firstPublishedAt desc)`
);
const { data: posts } = await useSanityQuery(POSTS_QUERY);
</script>
S
<template>
  <UContainer>
    <h1
      class="font-serif text-lg tracking-wide dark:text-gray-200 text-gray-600 mt-6"
    >
      André's Blog
    </h1>
    <UPageGrid class="mt-2">
      <PostCard v-for="post in posts" :key="post._id" :post />
    </UPageGrid>
  </UContainer>
</template>
